<template>
    <div>

      <h3 class="mt-3">Status</h3>

        <loader v-if="isLoading" class="col-sm-4 mt-4"></loader>

        <div v-else class="col-sm-4 mt-4">
            <button class="btn w-100 blue widest btnPill" :class="{'opacity-30': getSelectedEvent.status == statusId('Canceled')}" @click="setEventActive">Active</button>
            <button class="btn w-100 action widest btnPill" :class="{'opacity-30': getSelectedEvent.status == statusId('Active')}" @click="setEventcanceled">Canceled</button>
        </div>


        <div class="col-sm-10 mt-4" v-if="getSelectedEvent.status == statusId('Canceled')">
            <label class="full">
                Cancellation description
                <textarea class="bg-lighter w-100 mt-1" rows="2" v-model="getSelectedEvent.statusMessage" ></textarea>
            </label>

        </div>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import loader from '@/tools/loaders/loader1'

    export default {
        created: function(){
            this.getPossibleEventStatuse().then((response) => {
                this.isLoading = false
                this.possibleStatusAvailable = response;
            });
        },
        props: {
            validations: {
                type: Object
            }
        },
        data: function() {
            return {
                isLoading: true,
                possibleStatusAvailable: []
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent'
            ]),
        },
        asyncComputed: {

        },
        methods: {
            ...mapActions([
                'openModal',
                'setModalConfirmData'
            ]),
            setEventActive: function() {
                this.getSelectedEvent.status = this.statusId("Active");
                this.getSelectedEvent.setToCancel = false;
            },
            setEventcanceled: function() {
                this.getSelectedEvent.status = this.statusId("Canceled");
                this.getSelectedEvent.setToCancel = true;
            },
            calledEventModal: function() {
                let mainVm = this;
                let modalConfirmData = {
                    title:'Set status to canceled.',
                    message: '<strong>'+this.getSelectedEvent.product.name+'</strong> status will be set as <span class="color-6">canceled</span>.<br>Future bookings will be blocked for this event.',
                    buttons:[
                        {
                            text:'Yes',
                            class:'btn success px-5',
                            action: function(vm){
                                vm.getSelectedEvent.status = mainVm.statusId("Canceled");
                                vm.openModal('EventEdit');
                            }
                        },
                        {
                            text:'No',
                            class:'btn tertiary px-5',
                            action: function(vm){
                                vm.getSelectedEvent.status = mainVm.statusId("Active");
                                vm.openModal('EventEdit');
                            }
                        }
                    ]
                }
                this.setModalConfirmData(modalConfirmData);
                this.openModal('ModalConfirm');
            },
            getPossibleEventStatuse: async function() {
                try {
                    console.log('Fetching possible event status: ');
                    let response = await axios.get('api/settings/GetEventStatusList');

                    if (response && response.status === 200) {
                        console.log('fetching possible status done.');
                        console.log(response.data);
                        return response.data;
                    }
                }
                catch (error) {
                    console.log(error.response.data.message);
                }

            },
            statusId: function(statusLabel){

                for (let status of this.possibleStatusAvailable) {
                    if(statusLabel == status.description){
                        return status.id
                    }
                }
            }
        },
        components: {
            loader
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// areaStatus.vue?4a036258